import { connect } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import Unauthorized from "screens/components/basic/authorizedPage";


const PrivateRoutes = (props) => {
  const location = useLocation()
  const isAuthorized = (id, accessList, isOwner) => {
    if (isOwner && accessList && accessList.access && accessList.access.length === 0) return true; // always grant access to ALL pages for Store Owner
    if (id === 15) return false;  // always deny acccss to User Role List page except Store Owner
    return accessList &&
      accessList.access &&
      accessList.access[id] &&
      accessList.access[id].hasAccess;
  };

  const PrivateRouteComponent = () => {
    const { userRolePage, authenticatedUser } = props;

    if (userRolePage === undefined || authenticatedUser === undefined) {
      return null;  // avoid rendering the Unauthorized component when page is refreshed 
    }

    const isOwner = authenticatedUser && authenticatedUser.roles.includes("StoreOwner") ? true : false;
    return isAuthorized(props.pageIndex, userRolePage, isOwner)
  };

  if (location.pathname === "/userrole") {
    return <Outlet {...props} />
  } else {


    return PrivateRouteComponent() ? (
      // <ComposedComponent {...props} />
      <Outlet params={{
        ...props.userRolePage
      }} />
    ) : (
      <Unauthorized />
    );
  }


};
const mapStateToProps = (state) => ({
  userRolePage: state.entity.userRolePage,
  authenticatedUser: state.common.authenticatedUser
});

export default connect(mapStateToProps)(PrivateRoutes);
